
export { CollectionName } from "/home/sumanjuy/repos/trade-certification-main/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"